export function base64toBlob(b64Data) {
    return fetch(b64Data).then((res) => res.blob());
}
